import client from './client';

export interface UserProfile {
	id: number;
	name: string;
}

export interface User {
	id: number;
	email: string;
	name: string;
	active: boolean;
	profile: UserProfile;
}

export interface CreatedUser {
	id: number;
	email: string;
	name: string;
	password: string;
}

export interface ContractWithAssignment {
	id: number;
	name: string;
	assigned: boolean;
}

const usersApi = {
	getUsers: (search?: string) => {
		const params = search ? { search } : undefined;
		return client.get<{ users: User[] }>('/api/users', {
			params,
		});
	},

	createUser: (data: {
		email: string;
		name: string;
		profileId: number;
	}) => client.post<{ user: CreatedUser }>('/api/users', data),

	toggleUserActive: (userId: number, active: boolean) =>
		client.put<{ id: number; active: boolean }>(
			`/api/users/${userId}/active`,
			{ active },
		),

	getUserContracts: (userId: number) =>
		client.get<{ contracts: ContractWithAssignment[] }>(
			`/api/users/${userId}/contracts`,
		),

	updateUserContracts: (
		userId: number,
		contractIds: number[],
	) =>
		client.put<{ contractIds: number[] }>(
			`/api/users/${userId}/contracts`,
			{ contractIds },
		),

	getProfiles: () =>
		client.get<{ profiles: UserProfile[] }>(
			'/api/profiles',
		),

	changePassword: (userId: number) => {
		return client.post<{ success: boolean; password: string }>(
			'/api/change-user-password',
			{ userId },
		);
	},
};

export default usersApi;
